import cn from 'classnames';
import styles from './countryFlag.module.scss';

interface IProps {
  /**
   * ISO 3166-1 alpha-2 code, case-insensitive. Without it a neutral placeholder is shown.
   */
  countryCode?: string,
  className?: string,
}

const CountryFlag = ({ countryCode, className }: IProps) => (
  <span
    className={ cn(
      styles.countryFlag,
      className,
      countryCode ? [styles.fi, styles[`fi-${ countryCode.toLowerCase() }`]] : styles.placeholder,
    ) }
  />
);

export default CountryFlag;
